import React, {useEffect, useRef, useState} from 'react';
import axios from "axios";
import './styleMonth.css';
import './styleMonthAnimation.css';
import Cookies from 'js-cookie';
import {DOMEN_BASE} from "../../assets/config/constants";
import SelectBase from "../../components/select/SelectBase";
import GridMonth from "./gridMonth/gridMonth";
import BookingPreview from "../../components/BookingPreview";


function Month(props) {
    // const location = useLocation();
    // const c_item = location.state.curr_item;

    const [mYears, setYears] = useState((Cookies.get('year')) ? Cookies.get('year') : new Date().getFullYear());
    const [mMonths, setMonths] = useState((Cookies.get('month')) ? Cookies.get('month') : 1);
    const [isLoading, setIsLoading] = useState(true);
    const [dataMonth, setDataMonth] = useState(0);
    const [orient, setOrient] = useState((window.screen.availHeight > window.screen.availWidth) ? true : false);

    const [measurementStart, setMeasurementStart] = useState(0);
    const [selectedBooking, setSelectedBooking] = useState(null);

    // Глобальный объект для хранения времени
    const performanceMetrics = useRef({
        clickTime: 0,
        fetchStartTime: 0,
        fetchEndTime: 0,
        renderStartTime: 0,
        renderEndTime: 0
    });


    useEffect(() => {
            setIsLoading(true);
        },
        [mYears, mMonths]);


    useEffect(() => {
        let startTouchX = 0;
        let endTouchX = 0;
        let rasst = 0;

        const handleTouchStart = (e) => {
            startTouchX = e.changedTouches[0].pageX;
            // console.log('начало : ', startTouchX);
        };

        const handleTouchEnd = (e) => {
            endTouchX = e.changedTouches[0].pageX;
            // console.log('конец : ', endTouchX);
            rasst = Math.abs(startTouchX - endTouchX);
            if (rasst > 100) {
                const clickTime = performance.now();
                performanceMetrics.clickTime = clickTime;
                setMeasurementStart(clickTime); // ← это заставит useEffect сработать
                changeMonth((startTouchX < endTouchX) ? 1 : -1);
            }
        };

        const handleChangeOriontation = (e) => {
            setOrient((window.screen.availHeight > window.screen.availWidth) ? true : false);
        };

        window.addEventListener('touchstart', handleTouchStart);
        window.addEventListener('touchend', handleTouchEnd);
        window.addEventListener("orientationchange", handleChangeOriontation);


        return () => {
            window.removeEventListener('touchstart', handleTouchStart);
            window.removeEventListener('touchend', handleTouchEnd);
            window.removeEventListener('orientationchange', handleChangeOriontation);
        };


    });


    useEffect(() => {
        if (dataMonth && dataMonth.length > 0 && !isLoading && measurementStart > 0) {
            setTimeout(() => {
                const metrics = performanceMetrics;
                const renderCompleteTime = performance.now();

                if (metrics.clickTime && metrics.fetchEndTime) {
                    const totalTime = renderCompleteTime - metrics.clickTime;
                    const networkTime = metrics.fetchEndTime - metrics.fetchStartTime;
                    const jsProcessingTime = metrics.fetchStartTime - metrics.clickTime;
                    const renderTime = renderCompleteTime - metrics.fetchEndTime;

                    console.log('🚀 ========== ПРОИЗВОДИТЕЛЬНОСТЬ СВАЙПА ==========');
                    console.log(`🖱️  Время от свайпа до запроса: ${jsProcessingTime.toFixed(0)}ms`);
                    console.log(`🌐 Сетевой запрос: ${networkTime.toFixed(0)}ms`);
                    console.log(`🎨 Рендеринг: ${renderTime.toFixed(0)}ms`);
                    console.log(`🎯 ОБЩЕЕ ВРЕМЯ: ${totalTime.toFixed(0)}ms`);
                    console.log(`📊 Записей: ${dataMonth.length}`);
                    console.log('==============================================');

                    // showPerformanceBadge(totalTime);

                    // Сброс
                    metrics.clickTime = 0;
                    metrics.fetchStartTime = 0;
                    metrics.fetchEndTime = 0;
                    setMeasurementStart(0); // сбрасываем триггер
                }
            }, 300);
        }
    }, [dataMonth, isLoading, measurementStart]);


    const changeMonth = i_d => {
        // console.log('i_d', i_d);
        // console.log('месяц', mMonths);
        // console.log('год', mYears);
        if (i_d === 1) decMonth();
        else incMonth();
    };

    const incMonth = () => {
        const m = parseInt(mMonths);
        const y = parseInt(mYears);
        if (m < 12)
            setMonths(m + 1);
        else {
            setMonths(1);
            setYears(y + 1);
        }
    };

    const decMonth = () => {
        const m = parseInt(mMonths);
        const y = parseInt(mYears);
        if (m > 1)
            setMonths(m - 1);
        else {
            setMonths(12);
            setYears(y - 1);
        }
    };

    const getData = async () => {
        performanceMetrics.fetchStartTime = performance.now();
        return await axios.get(DOMEN_BASE + '/ui/getMonth.php', {
            params: {
                year: mYears,
                month: mMonths
            }
        })
            .then(({data}) => {
                performanceMetrics.fetchEndTime = performance.now();
                // console.log('data.records : ', data.records);
                return data.records;
            })
            .catch(err => {
                alert(err.message);
                // return false;
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (isLoading) {
            getData().then(t => setDataMonth(t));
        }
    });

    const handleSelectChangeYear = (e) => {
        setYears(e);
        Cookies.set('year', e);
        setIsLoading(true);
    };

    const handleSelectChangeMonth = (e) => {
        setMonths(e);
        Cookies.set('month', e);
        setIsLoading(true);
    };

    const getClientData = async (id) => {
        await axios.get(DOMEN_BASE + '/ui/getClientData.php', {
            params: {
                id: id,
            }
        })
            .then(({data}) => {
                setSelectedBooking((data) ? data.records : null);
                // return data;
            })
            .catch(err => {
                alert(err.message);
                // return false;
            });
    };


    return (
        <>
            <div>
                <div className="month_panel">

                    <SelectBase name="years" id="years" labelText="Год" curr_id={mYears} _rooms_id={mYears}
                                _set_function={handleSelectChangeYear} _filter={true}/>

                    <SelectBase name="months" id="months" labelText="Месяц" curr_id={mMonths} _rooms_id={mMonths}
                                _set_function={handleSelectChangeMonth} _filter={true}/>

                </div>
                {
                    (!orient) ?
                        <GridMonth _data={dataMonth} _clk={getClientData}/>
                        // <div className="grid_month" dangerouslySetInnerHTML={{__html: dataMonth}}/>
                        :
                        <div className="grid_month message4screen">Поверните телефон горизонтально</div>
                }
            </div>
            <BookingPreview
                booking={selectedBooking}
                onClose={() => setSelectedBooking(null)}
            />
        </>
    );
}

export default Month;
